import { useState } from "react";
import { duplicateReservation } from "@src/api/booking/booking";
import { getMyReservationList } from "@src/api/realtimeBooking/realtimeBooking";
import { isExternalUrl, HOSTNAME } from "@src/utils";

const key = "UTQJ9IKlPgPzMex7zrNShw%2BWklZNIILWt1UB51w%2Bnx0%3D";
export default function useDuplicateBooking() {
  const [isDuplicateBooking, setIsDuplicateBooking] = useState<boolean>(false);

  async function getDuplicateReservation(
    partnerUuid: string,
    userUuid: string,
    partnerId?: string | number,
    ignoreDuplicateCheck: boolean = false,
    hallName?: string,
  ) {
    try {
      const [normalRes, realtimeRes] = await Promise.all([
        duplicateReservation(partnerUuid, userUuid),
        getMyReservationList({ apiKey: key, uuid: userUuid }),
      ]);
      if (!ignoreDuplicateCheck) {
        if (normalRes.data.result === 409) {
          setIsDuplicateBooking(true);
          return;
        }

        const bookingHallList = realtimeRes.data.item
          .filter((hall) => hall.visitStateAlias === "방문예정")
          .map((h) => h.partnerUuid);

        if (bookingHallList.includes(partnerUuid)) {
          setIsDuplicateBooking(true);
          return;
        }
      }
      // 통합예약 > 방문날짜 선택페이지는 웹뷰 헤더 사용
      window.location.href = isExternalUrl(
        `${HOSTNAME}/booking/hall?partnerId=${partnerId}&partnerUuids=${partnerUuid}&hallName=${hallName}&origin=booking&hidetop=true`,
      );
    } catch (error) {
      console.error("Error in getDuplicateReservation", error);
    }
  }

  return {
    isDuplicateBooking,
    setIsDuplicateBooking,
    getDuplicateReservation,
  };
}
